import { useEffect } from "react";

import useUserGuideGroup from "shared/UserGuides/useUserGuideGroup";
import UserGuideGroup from "components/UserGuideGroup";
import UserGuideGroupSkeleton from "components/UserGuideGroup/Skeleton";

import useAssistantPanelLearnStore from "../../useStore";

const AssistantPanelLearnChaptersView = () => {
  const { navigationState, setNavigationState } = useAssistantPanelLearnStore();

  const groupId = navigationState.level === "chapters" ? navigationState.groupId : "";
  const { userGuideGroup, loading } = useUserGuideGroup({ id: groupId });

  useEffect(() => {
    if (!loading && !userGuideGroup?.chapters) {
      setNavigationState({ level: "groups" });
    }
  }, [loading, userGuideGroup, setNavigationState]);

  if (loading && !userGuideGroup) {
    return <UserGuideGroupSkeleton />;
  }

  if (!userGuideGroup) {
    return null;
  }

  return <UserGuideGroup key={groupId} userGuideGroup={userGuideGroup} groupId={groupId} />;
};

export default AssistantPanelLearnChaptersView;
